import get from 'lodash/get'

// Driver paths are stored in Firestore as either a JSON-stringified
// FeatureCollection of LineString features (one feature per contiguous
// segment, broken on GPS gaps) or, for older entries, a single Feature
// LineString. Return one `{ coordinates, driver }` segment per feature — the
// canonical breadcrumb shape (matching the route page's redux state) so the
// hover tooltip can attribute each point to its driver. Callers render one
// polyline per segment instead of joining all points across gap boundaries.
const parseDriverPathSegments = input => {
  if (input == null) return []

  let parsed = input
  if (typeof input === 'string') {
    try {
      parsed = JSON.parse(input)
    } catch {
      return []
    }
  }

  if (parsed?.type === 'FeatureCollection') {
    return (parsed.features || [])
      .filter(f => get(f, 'geometry.type') === 'LineString')
      .map(f => ({ coordinates: get(f, 'geometry.coordinates', []), driver: get(f, 'properties.driverUsername') }))
      .filter(({ coordinates }) => Array.isArray(coordinates) && coordinates.length >= 2)
  }

  if (parsed?.type === 'Feature' && get(parsed, 'geometry.type') === 'LineString') {
    const coordinates = get(parsed, 'geometry.coordinates', [])
    if (Array.isArray(coordinates) && coordinates.length >= 2) {
      return [{ coordinates, driver: get(parsed, 'properties.driverUsername') }]
    }
  }

  return []
}

export default parseDriverPathSegments
